<script context="module" lang="ts">
	export enum TableColumn {
		none = "none",
		storeApplicationStatus = "storeApplicationStatus",
		storeName = "name",
		storeType = "storeType2",
		storeAddress = "formattedAddress2",
		storeStatus = "storeStatus",
		createDate = "createDate",
	}
	export type SortOrder = "none" | "asc" | "desc";

</script>

<script lang="ts">
	//UI
	import { SortByIcon } from "@hitit/new_ui";
	//Utils
	import { processingDate } from '@hitit/hub/src/v7/utils/Date';
	import { t } from "@hitit/hub/src/stores";
	import moment from "moment";
	//Types
	import type { StoreSearchResult } from "@hitit/api";
	//Props
	export let columnHeadClickHandler: (
		columnName: TableColumn
	) => void = () => {};
	export let rowClickHandler = (storeId: string) => {};
	export let sortOrder: SortOrder = "none";
	export let sortBy: TableColumn = TableColumn.none;
	export let stores: StoreSearchResult[] = [];
	//Constants
	const headColumn = Object.keys(TableColumn).filter((v) => v !== "none");
	const columnConvert = (key: string) => {
		switch (key) {
			case "none":
				return TableColumn.none;
			case "storeApplicationStatus":
				return TableColumn.storeApplicationStatus;
			case "storeName":
				return TableColumn.storeName;
			case "storeType":
				return TableColumn.storeType;
			case "storeStatus":
				return TableColumn.storeStatus;
			case "storeAddress":
				return TableColumn.storeAddress;
			case "createDate":
				return TableColumn.createDate;
			default:
				return TableColumn.none;
		}
	};
	//Variables
	//Functions
	//Do

</script>

<div class="container">
	<div class="header">
		{#each headColumn as column}
			<div
				class={`col ${column}`}
				on:click={() => columnHeadClickHandler(columnConvert(column))}>
				{$t(`mbr.search.${column}`)}
				<span class="icon">
					<SortByIcon
						orderStatus={columnConvert(column) === sortBy ? sortOrder : 'none'} />
				</span>
			</div>
		{/each}
	</div>
	<div class="body">
		{#each stores as store}
			<div class="row" on:click={() => rowClickHandler(store.id)}>
				<div class="col storeApplicationStatus">
					{store.storeApplicationStatus}
				</div>
				<div class="col storeName">{store.name}</div>
				<div class="col storeType">{store.storeType2}</div>
				<div class="col storeAddress">
					{store.formattedAddress1 || store.formattedAddress2}
				</div>
				<div class="col storeStatus">{store.storeStatus}</div>
				<div class="col createDate">{processingDate(store.createdDate)}</div>
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		.header {
			display: none;
			color: #6d6f76;
			.col {
				&:hover {
					cursor: pointer;
				}
			}
		}
		.body {
			display: flex;
			flex-direction: column;
			color: #46474b;
			.row {
				display: flex;
				transition: background-color 0.5s;
				padding: 20px 0px;
				&:not(:last-child) {
					border-bottom: 1px solid #e6e7ec;
				}
				&:hover {
					cursor: pointer;
					background-color: #f0f0f4;
				}
				.col {
					display: none;
				}

				.storeName {
					display: flex !important;
					font-weight: 500;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			display: flex;
			width: 100%;
			gap: 10px;
			.header {
				display: flex;
				font-size: 1.25rem;
				.col {
					gap: 4px;
				}
				.icon {
					width: 16px;
					height: 17px;
				}
			}

			.body {
				display: flex;
				font-size: 1.25rem;

				.row {
					flex-direction: row;
					box-sizing: border-box;
					padding: 20px 0px;
				}

				.col {
					display: flex !important;
				}
			}

			.col {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				word-break: break-all;
			}

			.storeApplicationStatus {
				width: calc(100% * (110 / 1550));
			}
			.storeName {
				width: calc(100% * (358 / 1550));
			}
			.storeType {
				width: calc(100% * (138 / 1550));
			}
			.storeAddress {
				width: calc(100% * (505 / 1550));
			}
			.storeStatus {
				width: calc(100% * (100 / 1550));
			}
			.createDate {
				width: calc(100% * (338 / 1550));
			}
		}
	}

</style>
